<label class="esf-form-item__label" *ngIf="label">{{ label }}<app-optional *ngIf="optional"></app-optional></label>
<div class="esf-toggle">
  <input class="esf-toggle__input"
         type="checkbox"
         [formControl]="formControl"
         [id]="id">
  <label class="esf-toggle__label" [for]="id">
    {{ innerLabel }}
    <div class="esf-toggle__button">
      <div class="esf-toggle__button-background">
        <div class="esf-toggle__button-handle"></div>
      </div>
    </div>
  </label>
</div>
